'use client';

import Cookies from 'js-cookie';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { CONSENT_COOKIE_NAME } from '@/app/constants/cookies';
import { ERROR_PAGE_ATTRIBUTE } from '@/app/contents/errors';
import {
  LCV_NOT_DISPLAY_CONSENT_PATHS,
  NOT_DISPLAY_CONSENT_PATHS,
} from '@/app/contents/pdpa';
import { isServer } from '@/app/utils/browser';

const ConsentPopup = dynamic(
  () =>
    import('@/app/components/consent/popup').then((mod) => mod.ConsentPopup),
  {
    ssr: false,
  }
);

const isCV = process.env.NEXT_PUBLIC_WEB === 'cv';

export const Consent = () => {
  const pathname = usePathname();

  const [shouldRenderConsent, setShouldRenderConsent] =
    useState<boolean>(false);

  const isErrorPage =
    !isServer && document.body.getAttribute(ERROR_PAGE_ATTRIBUTE) === 'true';

  useEffect(() => {
    const ignorePath = isCV
      ? NOT_DISPLAY_CONSENT_PATHS
      : LCV_NOT_DISPLAY_CONSENT_PATHS;

    const isShouldIgnore = ignorePath.some((prefix) =>
      (pathname ?? '').startsWith(prefix)
    );

    if (isShouldIgnore) {
      return setShouldRenderConsent(false);
    }

    const consentCookie = Cookies.get(CONSENT_COOKIE_NAME);
    setShouldRenderConsent(!consentCookie);
  }, [pathname]);

  const handleConsentClose = () => {
    setShouldRenderConsent(false);
  };

  if (isErrorPage) {
    return null;
  }

  return (
    <>
      {!!shouldRenderConsent && <ConsentPopup onClose={handleConsentClose} />}
    </>
  );
};
